import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Form, Input, Button, message, Checkbox } from 'antd'
import { signup } from '../../redux/auth'
import { sendEmail } from '../../redux/common'
import { CAPTCHA_APP_ID, EMAIL_TEMPLATE } from '../../utils/constant'
import { reportSignupClick, reportSignupExp, reportSignupSuccess } from '../../utils/report'
import OAuth from '../../components/OAuth'
import Logo from '../../components/Logo'

class Signup extends React.Component {
  constructor(props) {
    super(props)
    const urlObj = new URL(window.location.href)
    const email = urlObj.searchParams.get('email') || ''
    const domain = urlObj.searchParams.get('domain') || ''
    this.state = {
      email,
      password: '',
      verificationCode: '',
      emailSended: false,
      canSendAfterSeconds: 60,
      domain,
      termsAndPrivacyReaded: false
    }
  }

  componentDidMount() {
    reportSignupExp()
    if (window) {
      window.onkeypress = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault()
          e.stopPropagation()
          this.handleClickSignup()
        }
      }
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true
    if (window) {
      window.onkeypress = null
    }
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  handleClickSignup = async () => {
    const { email, password, verificationCode, termsAndPrivacyReaded, domain } = this.state
    const { t, i18n } = this.props

    if (!email || !email.trim()) {
      return message.error(t('warning.emailRequired'))
    }

    if (!password || !password.trim()) {
      return message.error(t('warning.passwordRequired'))
    }

    if (!verificationCode || !verificationCode.trim()) {
      return message.error(t('warning.verificationCodeRequired'))
    }

    if (!termsAndPrivacyReaded) {
      return message.error(t('warning.agreeTermsAndPolicyFirst'))
    }

    const {captchaTicket, captchaRandstr, captchaPass} = await new Promise((resolve, reject) => {
      const captcha = new window.TencentCaptcha(CAPTCHA_APP_ID, (res) => {
        if (res.ret === 0 && res.ticket) {
          resolve({captchaTicket: res.ticket, captchaRandstr: res.randstr, captchaPass: true})
        } else {
          console.error(t('warning.captchaFailed') + ':', JSON.stringify(res))
        }
      }, {
        needFeedBack: 'https://support.qq.com/products/109240',
        userLanguage: i18n.language,
      })
      captcha.show()
    })
    if (!captchaTicket || !captchaPass) {
      return message.error(t('warning.captchaRequired'))
    }

    const invitationCode = localStorage.getItem('INVITATION_CODE') || ''
    this.props.dispatch(signup({ email, password, verificationCode, invitationCode, captchaTicket, captchaRandstr }))
      .then((result) => {
        if (result.errorMsg) {
          return message.error(result.errorMsg)
        } else {
          if (invitationCode) {
            localStorage.removeItem('INVITATION_CODE')
          }
          if (domain) {
            this.props.history.replace(`/guide/createcertificate?domain=${encodeURIComponent(domain)}`)
          } else {
            this.props.history.replace('/guide/createcertificate')
          }
          reportSignupSuccess()
        }
      }).catch((error) => {
        return message.error(t('warning.unknownError') + `:${error}`)
      })
    
    reportSignupClick()
  }

  handleChangeEmail = (e) => {
    const email = e.target.value
    this.setState({
      email,
      emailSended: false,
      canSendAfterSeconds: 60
    })
  }

  handleChangePassword = (e) => {
    this.setState({
      password: e.target.value
    })
  }

  handleChangeVerificationCode = (e) => {
    this.setState({
      verificationCode: e.target.value
    })
  }

  handleClickSignin = () => {
    this.props.history.push('/signin')
  }

  handleSendEmailVerification = () => {
    const { t } = this.props
    const { email, emailSended, canSendAfterSeconds } = this.state
    if (emailSended && canSendAfterSeconds >= 1) {
      return message.error(t('warning.sendEmailTooOften'))
    }

    if (!email || !email.trim()) {
      return message.error(t('warning.emailRequired'))
    }

    this.props.dispatch(sendEmail({ email, templateId: EMAIL_TEMPLATE.VERIFICATION_CODE })).then(result => {
      if (this.isUnmounted) {
        return
      }

      if (result.errorMsg) {
        return message.error(result.errorMsg)
      }

      this.setState({
        canSendAfterSeconds: 60,
        emailSended: true
      })

      this.timer = setInterval(() => {
        const { canSendAfterSeconds } = this.state

        this.setState({
          canSendAfterSeconds: canSendAfterSeconds - 1
        })

        if (canSendAfterSeconds <= 1) {
          clearInterval(this.timer)
        }
      }, 1000)

      message.success(t('warning.emailVerificationCodeSent'))
    })
  }

  handlerClickTitle = () => {
    this.props.history.push('/')
  }

  handleChangeTermsAndPrivacyReaded =(e) => {
    this.setState({
      termsAndPrivacyReaded: e.target.checked
    })
  }

  render() {
    const { t } = this.props
    const { email, emailSended, canSendAfterSeconds } = this.state

    return (
      <div className="area signup">
        <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <div className='form-container'>
          <Form>
            <div className='title' onClick={this.handlerClickTitle}>
              <Logo />
              <h4>{t('slogn.freeHttps')}&nbsp;•&nbsp;{t('slogn.autoUpdate')}&nbsp;•&nbsp;{t('slogn.autoDeploy')}&nbsp;•&nbsp;{t('slogn.autoMonitor')}</h4>
            </div>
            <Form.Item>
              <Input
                value={email}
                placeholder={t('signup.placeholderEmail')}
                onChange={this.handleChangeEmail}
              />
            </Form.Item>
            <Form.Item>
              <Input.Password
                placeholder={t('signup.placeholderPassword')}
                visibilityToggle={false}
                onChange={this.handleChangePassword}
              />
            </Form.Item>
            <Form.Item>
              <Input.Search
                placeholder={t('signup.placeholderVerificationCode')}
                maxLength={6}
                enterButton={emailSended ? canSendAfterSeconds >= 1 ? t('signup.canResendIn', {val: canSendAfterSeconds}) : t('signup.resendVerificationCode') : t('signup.sendVerificationCode')}
                onChange={this.handleChangeVerificationCode}
                onSearch={this.handleSendEmailVerification}
              />
            </Form.Item>
            <div style={{display: 'flex', justifyContent: 'fetch-start', alignItems: 'center', color: "rgba(0, 0, 0, 0,65)", fontSize: '12px', margin: '-2px 0 22px'}}>
              <Checkbox checked={this.state.termsAndPrivacyReaded} onChange={this.handleChangeTermsAndPrivacyReaded}/>
              &nbsp;{t('signup.termsAndPrivacyReaded')}&nbsp;
              <a href='/docs/terms' target='_blank' style={{}} >{t('policy.terms')}</a>、
              <a href='/docs/privacy' target='_blank' style={{color: "rgba(0, 0, 0, 0,65)", fontSize: '12px'}}  >{t('policy.privacy')}</a>
            </div>
            <Button type='primary' block onClick={this.handleClickSignup}>{t('header.register')}</Button>
            <OAuth/>
            <Button type='link' onClick={this.handleClickSignin}>{t('signup.haveAccount')}</Button>
          </Form>
        </div>
      </div>
    )
  }
}

Signup = withTranslation()(connect()(Signup))

export default Signup
